import React from "react";
import logo from "../assets/logo-name.png";
import unauthorized from "../assets/un-authorized.png";
import { useNavigate } from "react-router-dom";

const UnAuthorized = () => {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen w-full flex-col items-center p-5">
      {/* Logo */}
      <div className="flex w-full justify-start">
        <img src={logo} alt="Logo" className="h-14 sm:h-16" />
      </div>

      {/* Unauthorized Image */}
      <div className="flex w-full max-w-md flex-1 flex-col items-center justify-center">
        <img
          src={unauthorized}
          alt="Unauthorized Access"
          className="w-full max-w-xs object-cover sm:max-w-sm"
        />

        {/* Text Content */}
        <div className="mt-4 flex flex-col items-center gap-4 text-center">
          <h2 className="text-lg font-semibold">No Authorization Found</h2>
          <p className="px-4 text-gray-600">
            This page is not publicly available. To access it, please log in
            first.
          </p>

          {/* Go Back Button */}
          <button
            onClick={() => navigate(-1)} // Navigates back
            className="w-full rounded-md bg-[#FFAE00] py-2 text-white transition hover:bg-[#E09C00] "
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnAuthorized;
